import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import NavigationBar from '../NavigationBar';
import DOTheme from './doTheme';
import DOIndex from './DOIndex';

/**
 * Shared page shell for every Direct Orders screen: app navigation, the
 * section index on the left (counts and destinations), and the page itself on
 * a white sheet. `showNav={false}` hides the index for focused tasks such as
 * raising a new order, which get a back link instead.
 */
const DOLayout = ({ title, subtitle, actions, back, showNav = true, children }) => (
  <DOTheme>
    <Layout className="do-shell do-scope">
      <NavigationBar />
      <main className={`do-main${showNav ? ' do-main--indexed' : ''}`}>
        {showNav && <DOIndex />}
        <div className="do-sheet">
          <div className="do-container">
            {back && (
              <Link to={back.to} className="do-back">
                <ArrowLeftOutlined aria-hidden="true" />
                {back.label}
              </Link>
            )}
            <header className="do-header">
              <div>
                <h1 className="do-title">{title}</h1>
                {subtitle && <p className="do-subtitle">{subtitle}</p>}
              </div>
              {actions && <div className="do-header__actions">{actions}</div>}
            </header>
            {children}
          </div>
        </div>
      </main>
    </Layout>
  </DOTheme>
);

export default DOLayout;
